// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Top5Comedy_container__Oprid {
  width: 100%;
  max-width: 95%;
  margin: 0 auto;
  padding: 0px;
  background: #1A1A1A;
}

.Top5Comedy_header__LUREm {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0rem;
}

.Top5Comedy_header__LUREm h2 {
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
}

/* Swiper Styles */
.Top5Comedy_swiper__L9hbY {
  width: 100%;
  height: 100%;
}

/* Swiper Navigation Buttons */
.swiper-button-prev,
.swiper-button-next {
  color: #ffffff;
  background: rgba(0, 0, 0, 0.5);
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 1rem;
}

.swiper-button-disabled {
  opacity: 0 !important;
}

/* Comedy Item Card */
.Top5Comedy_comedyItem__Ih\\+et {
  position: relative;
  background-color: #1a1a1a;
  border-radius: 0.5rem;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  outline: none;
  height: 100%;
}

.Top5Comedy_comedyItem__Ih\\+et:hover,
.Top5Comedy_comedyItem__Ih\\+et:focus {
  transform: scale(1.02);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.Top5Comedy_comedyItem__Ih\\+et:active {
  transform: scale(0.98);
}

/* Image Container */
.Top5Comedy_imageContainer__rQWq- {
  position: relative;
  aspect-ratio: 3/4;
}

.Top5Comedy_image__YxLDo {
  width: 99%;
  height: 100%;
  object-fit: cover;
}

/* Number Badge */
.Top5Comedy_numberBadge__rIkPO {
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: #dc2626;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.Top5Comedy_numberBadge__rIkPO span {
  font-size: 1.25rem;
  font-weight: bold;
  color: white;
}

/* Responsive Design for Mobile */
@media (max-width: 768px) {
  .Top5Comedy_container__Oprid {
    padding: 0;
  }

  .Top5Comedy_header__LUREm h2 {
    font-size: 18px;
  }

  /* Reduce swiper button size */
  .swiper-button-prev,
  .swiper-button-next {
    width: 30px;
    height: 30px;
  }

  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 0.9rem;
  }

  .Top5Comedy_numberBadge__rIkPO {
    width: 2rem;
    height: 2rem;
  }

  .Top5Comedy_numberBadge__rIkPO span {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .Top5Comedy_container__Oprid {
    padding: 0rem;
  }

  .Top5Comedy_header__LUREm h2 {
    font-size: 18px;
  font-weight: bold;
  }

  .Top5Comedy_comedyItem__Ih\\+et {
    border-radius: 0.4rem;
  }

  .Top5Comedy_numberBadge__rIkPO {
    width: 1.8rem;
    height: 1.8rem;
  }

  .Top5Comedy_numberBadge__rIkPO span {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/AudioPage/components/Css/Top5Comedy.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;AACd;;AAEA,8BAA8B;AAC9B;;EAEE,cAAc;EACd,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,qDAAqD;EACrD,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA,8BAA8B;EAC9B;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB,iBAAiB;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".container {\n  width: 100%;\n  max-width: 95%;\n  margin: 0 auto;\n  padding: 0px;\n  background: #1A1A1A;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0rem;\n}\n\n.header h2 {\n  font-size: 20px;\n  font-weight: bold;\n  color: #ffffff;\n}\n\n/* Swiper Styles */\n.swiper {\n  width: 100%;\n  height: 100%;\n}\n\n/* Swiper Navigation Buttons */\n:global(.swiper-button-prev),\n:global(.swiper-button-next) {\n  color: #ffffff;\n  background: rgba(0, 0, 0, 0.5);\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n}\n\n:global(.swiper-button-prev:after),\n:global(.swiper-button-next:after) {\n  font-size: 1rem;\n}\n\n:global(.swiper-button-disabled) {\n  opacity: 0 !important;\n}\n\n/* Comedy Item Card */\n.comedyItem {\n  position: relative;\n  background-color: #1a1a1a;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  outline: none;\n  height: 100%;\n}\n\n.comedyItem:hover,\n.comedyItem:focus {\n  transform: scale(1.02);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.comedyItem:active {\n  transform: scale(0.98);\n}\n\n/* Image Container */\n.imageContainer {\n  position: relative;\n  aspect-ratio: 3/4;\n}\n\n.image {\n  width: 99%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Number Badge */\n.numberBadge {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  background-color: #dc2626;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n}\n\n.numberBadge span {\n  font-size: 1.25rem;\n  font-weight: bold;\n  color: white;\n}\n\n/* Responsive Design for Mobile */\n@media (max-width: 768px) {\n  .container {\n    padding: 0;\n  }\n\n  .header h2 {\n    font-size: 18px;\n  }\n\n  /* Reduce swiper button size */\n  :global(.swiper-button-prev),\n  :global(.swiper-button-next) {\n    width: 30px;\n    height: 30px;\n  }\n\n  :global(.swiper-button-prev:after),\n  :global(.swiper-button-next:after) {\n    font-size: 0.9rem;\n  }\n\n  .numberBadge {\n    width: 2rem;\n    height: 2rem;\n  }\n\n  .numberBadge span {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .container {\n    padding: 0rem;\n  }\n\n  .header h2 {\n    font-size: 18px;\n  font-weight: bold;\n  }\n\n  .comedyItem {\n    border-radius: 0.4rem;\n  }\n\n  .numberBadge {\n    width: 1.8rem;\n    height: 1.8rem;\n  }\n\n  .numberBadge span {\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Top5Comedy_container__Oprid`,
	"header": `Top5Comedy_header__LUREm`,
	"swiper": `Top5Comedy_swiper__L9hbY`,
	"comedyItem": `Top5Comedy_comedyItem__Ih+et`,
	"imageContainer": `Top5Comedy_imageContainer__rQWq-`,
	"image": `Top5Comedy_image__YxLDo`,
	"numberBadge": `Top5Comedy_numberBadge__rIkPO`
};
export default ___CSS_LOADER_EXPORT___;
